import React from 'react';
import { useCarouselContext } from '../Carousel.context';
import { FixMeLater } from '../../../utils';

export interface CarouselSlideProps {
    /**
     * The slide content.
     */
    children: React.ReactNode;
}

export const CarouselSlide = React.forwardRef(function CarouselSlide(
    props: CarouselSlideProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { children, ...other } = props;

    const { orientation } = useCarouselContext();

    return (
        <div ref={ref} data-carousel-slide={true} data-orientation={orientation} {...other}>
            {children}
        </div>
    );
});
